// id, name, email, icon=view
// view: details  all data in front
//textarea: message 
//accept and reject
import './style.css'
import { FormTable, FormTableCell, FormTableRow } from "../../components/Form";
import PanelLayout from "../panelComponents/PanelLayout/PanelLayout";
import { IoIosEye } from "react-icons/io";
import { Button } from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import authService from '../../service/auth';

const ReturnList = () => {

    const [taxFileList, setTaxFileList] = useState(null);


    useEffect(()=>{
        authService?.taxfilesList()
            .then((res) =>{
                console.log("taxfilelist",res?.data?.response?.taxfiles);
                setTaxFileList(res?.data?.response?.taxfiles)
            })
            .catch((err) => {
                console.log(err)
            })
    },[])

    const navigate = useNavigate()

    return<PanelLayout>
        <div className="returnlist-section">
            <div className="returnlist-inner-div">
                <div className="returnlist-table">
                    <div className='returnlist-list-row header'>
                        <span style={{width: '10%'}}><p>Id</p></span>
                        <span style={{width: '30%'}}><p>Name</p></span>
                        <span style={{width: '30%'}}><p>Email</p></span>
                        <span style={{width: '15%'}}><p>Status</p></span>
                        <span style={{width: '15%'}}><p>Action</p></span>
                    </div>
                    {taxFileList?.map((itm,index) => {
                        return<div className="returnlist-list-row" key={index}>
                            <span style={{width: '10%'}}><p>{itm?.id}</p></span>
                            <span style={{width: '30%'}}><p>{`${itm?.firstname} ${itm?.lastname}`}</p></span>
                            <span style={{width: '30%'}}><p>{itm?.email}</p></span>
                            <span
                                className={itm?.status === 'active' ? 'active' : itm?.status === 'pending' ? 'pending' : itm?.status === 'failed' ? 'failed' : itm?.status === 'NEW_REQUEST' ? 'new-request': ''}
                                style={{width: '15%'}}><p>{itm?.file_status}</p></span>
                            <span style={{width: '15%'}}>
                                <Button title={<IoIosEye />} varient="icon" onClick={()=>navigate('/details/'+itm?.id)} />
                            </span>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </PanelLayout>
}

export default ReturnList;

const user = [
    {
        id: 1,
        name: 'Lokesh',
        email: 'lokesh@gmail.com',
        status: 'active',
    },
    {
        id: 2,
        name: 'Lokesh',
        email: 'lokesh@gmail.com',
        status: 'pending',
    },
    {
        id: 3,
        name: 'Lokesh',
        email: 'lokesh@gmail.com',
        status: 'active',
    },
    {
        id: 4,
        name: 'Lokesh',
        email: 'lokesh@gmail.com',
        status: 'failed',
    },
    {
        id: 5,
        name: 'Lokesh',
        email: 'lokesh@gmail.com',
        status: 'active',
    },
]